import axios from 'src/store/vue-axios/axios.js'

export default class Channels {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // LIST -> /channels
  static channelsWithDisabledUrl = () => '/channels?with_disabled=1&'

  // START -> /channels/*
  static channelsStartUrl = () => '/channels/start'
  static channelsStartConversationUrl = () => '/channels/start-conversation'
  static channelsJoinByCodeUrl = () => '/channels/join-by-code'
  static channelsPersonalUrl = () => '/channels/personal-channel'
  static channelsStartTeacherParentUrl = () => '/channels/start-teacher-parent'

  // CONTENT MOVE -> /channels/*
  static channelAvailForContentMoveUrl = () => '/channels/content-move/available'
  static channelSingleRelatedChannelForContentMoveUrl = (channelId) => `/channels/${channelId}/content-move/related-channels/single`
  static channelRelatedChannelsForContentMoveUrl = (channelId) => `/channels/${channelId}/content-move/related-channels`
  static channelContentMoveSubmitUrl = () => '/channels/content-move/move'
  static channelContentMoveArchiveUrl = (channelId) => `/channels/${channelId}/content-move/archive`
  static channelContentMoveStartEmptyUrl = (channelId) => `/channels/${channelId}/content-move/start`

  // CHANNELS -> /channels/${channelId}*
  static channelsByIdUrl = (channelId) => `/channels/${channelId}`
  static channelsByIdLeavableUrl = (channelId) => `/channels/${channelId}/leavable`
  static channelsByIdMuteUrl = (channelId) => `/channels/${channelId}/mute`
  static channelsByIdLeaveUrl = (channelId) => `/channels/${channelId}/leave`
  static channelsByIdGenerateCodeUrl = (channelId) => `/channels/${channelId}/code`
  static channelsByIdArchiveUrl = (channelId) => `/channels/${channelId}/archive`
  static channelsByIdUnarchiveUrl = (channelId) => `/channels/${channelId}/unarchive`
  static channelsByIdNewsUrl = (channelId, page, search = '') => `/channels/${channelId}/news?page=${page}&search=${search}`
  static channelsByIdOneWayToggleUrl = (channelId) => `/channels/${channelId}/oneway`
  static channelsByIdStateUrl = (channelId) => `/channels/${channelId}/state`
  static channelsByIdClearMessagesUrl = (channelId) => `/channels/${channelId}/clear-messages`
  static channelsByIdMemberlistUrl = (channelId) => `/channels/${channelId}/memberlist`
  static channelsByIdFullHistoryUrl = (channelId) => `/channels/${channelId}/full-history`
  static channelsByIdVoiceMessagesUrl = (channelId) => `/channels/${channelId}/voice-messages`
  static channelsByIdMetrics = (channelId) => `/channels/${channelId}/metrics`

  // USERS -> /channels/${channelId}/users*
  static channelsByIdUsersUrl = (channelId) => `/channels/${channelId}/users`
  static channelsByIdUsersRemoveUrl = (channelId) => `/channels/${channelId}/users/remove`
  static channelsByIdUsersAddUrl = (channelId) => `/channels/${channelId}/users/add`
  static channelsByIdUsersToggleAdminUrl = (channelId) => `/channels/${channelId}/users/toggle-admin`

  // MESSAGE -> /channels/chat/${chatId}/messages*
  static channelsByIdMessagesUrl = (chatId, page) => `/channels/chats/${chatId}/messages?page=${page}`
  static channelChatMessagesSearchUrl = () => '/channels/chats/messages/search'

  // CONFERENCES -> /channels/${channelId}/conferences/*
  static channelsByIdConferencesUrl = (channelId) => `/channels/${channelId}/conferences`
  static channelsByIdConferencesByIdUrl = (channelId, conferenceId) => `/channels/${channelId}/conferences/${conferenceId}`
  static channelsByIdEndConferencesByIdUrl = (channelId, conferenceId) => `/channels/${channelId}/conferences/${conferenceId}/end-conference`
  static channelsByIdConferencesByIdFeedbackUrl = (channelId, conferenceId) => `/channels/${channelId}/conferences/${conferenceId}/feedback`
  static channelsByIdConferencesByIdParticipantsUrl = (channelId, conferenceId) => `/channels/${channelId}/conferences/${conferenceId}/participants`
  static channelsByIdConferencesByIdJoinUrl = (channelId, conferenceId) => `/channels/${channelId}/conferences/${conferenceId}/join`

  // CHAT -> /channels/chats/${chatId}*
  static channelChatByIdReadUrl = (chatId) => `/channels/chats/${chatId}/read`
  static channelChatByIdUnReadUrl = (chatId) => `/channels/chats/${chatId}/unread`
  static channelsByIdPinUrl = (chatId) => `/channels/chats/${chatId}/pin`

  // CHAT -> /channels/chats/${chatId}/messages*
  static channelChatByIdMessagesUrl = (chatId) => `/channels/chats/${chatId}/messages`

  static channelChatByIdMessagesForwardUrl = (chatId) => `/channels/chats/${chatId}/messages/forward`

  static channelChatByIdMessagesPaginatedUrl = (chatId, page, only_unseen) => {
    if (only_unseen) return `/channels/chats/${chatId}/messages?page=${page}&is_read=false`
    return `/channels/chats/${chatId}/messages?page=${page}`
  }

  static channelChatByIdSurveyUrl = (chatId) => `/channels/chats/${chatId}/messages/survey`
  static channelChatByIdKnockUrl = (chatId) => `/channels/chats/${chatId}/messages/knock`
  static channelChatByIdVoiceUrl = (chatId) => `/channels/chats/${chatId}/messages/voice`
  static channelChatByIdMessageByIdUrl = (chatId, messageId) => `/channels/chats/${chatId}/messages/${messageId}`
  static channelChatByIdReadersUrl = (chatId, messageId) => `/channels/chats/${chatId}/messages/${messageId}/readers`
  static channelChatByIdReadersPaginatedSearchUrl = (chatId, messageId, page, searchVal) => `/channels/chats/${chatId}/messages/${messageId}/readers?page=${page}&search=${searchVal}`
  static channelChatByIdMessageByDateUrl = (chatId, page, date) => `/channels/chats/${chatId}/messages?page=${page}&updated_at=${date}`
  static channelTranslateMessageByChannelIdUrl = (messageId, language, chatId) => `channels/chats/${chatId}/messages/${messageId}/translate?lang=${language}`
  static channelTranslationSupportedLanguagesUrl = () => '/channels/translations/supported-languages'

  // CLOUD -> /channels/cloud/${cloudId}*
  static channelCloudByIdUrl = (cloudId) => `/channels/cloud/${cloudId}`
  static channelCloudByIdUploadUrl = (cloudId) => `/channels/cloud/${cloudId}/upload`
  static channelCloudByIdCreateDirUrl = (cloudId) => `/channels/cloud/${cloudId}/create-directory`
  static channelCloudByIdCreateUrl = (cloudId) => `/channels/cloud/${cloudId}/create`
  static channelCloudByIdRenameFileUrl = (cloudId) => `/channels/cloud/${cloudId}/rename`
  static channelCloudByIdDeleteFileUrl = (cloudId) => `/channels/cloud/${cloudId}/delete`

  // CLOUD -> /channels/cloud/${cloudId}/files*
  static channelCloudByIdFilesFullPathUrl = (cloudId, fileId, path, orderBy, orderDir, fileType, limit) => `/channels/cloud/${cloudId}/files?file=${fileId}&path=${path || ''}&order-by=${orderBy}&order-dir=${orderDir}&file_type=${fileType}&limit=${limit}`
  static channelCloudByIdFilesByPathUrl = (cloudId, path) => `/channels/cloud/${cloudId}/files?path=${path}`
  static channelCloudByIdFileByIdUrl = (cloudId, fileId) => `/channels/cloud/${cloudId}/files/${fileId}`
  static channelCloudByIdFileByIChangeCollaborationUrl = (cloudId, fileId) => `/channels/cloud/${cloudId}/files/${fileId}/change`
  static channelCloudByIdMoveFilesUrl = (cloudId) => `/channels/cloud/${cloudId}/files/move`

  // SURVEYS -> /channels/surveys/*
  static channelSurveyUrl = () => '/channels/surveys'

  // SURVEYS -> /channels/surveys/${surveyId}*
  static channelSurveyByIdUrl = (surveyId) => `/channels/surveys/${surveyId}`
  static channelEndSurveyByIdUrl = (surveyId) => `/channels/surveys/${surveyId}/end`
  static channelVoteSurveyByIdUrl = (surveyId) => `/channels/surveys/${surveyId}/vote`
  static channelSurveyResultsAnsweredByIdUrl = (surveyId, answered) => `/channels/surveys/${surveyId}/results?answered=${answered}`

  // NEWS -> /channels/news/*
  static channelNewsUrl = () => '/channels/news'
  static channelNewsUploadUrl = () => '/channels/news/upload'
  static channelNewsDeleteAttachmentUrl = () => '/attachments/delete'
  static channelNewsAiContentUrl = () => '/ai/news/generate'
  static channelNewsAiTextFeedbackUrl = () => '/ai/news/feedback'

  // NEWS -> /channels/news/${newsId}*
  static channelNewsByIdUrl = (newsId) => `/channels/news/${newsId}`
  static channelNewsAttachmentByIdUrl = (attachmentId) => `/channels/news/attachments/${attachmentId}`
  static channelConfirmNewsByIdUrl = (newsId) => `/channels/news/${newsId}/confirm`
  static channelPinNewsByIdUrl = (newsId) => `/channels/news/${newsId}/pin`
  static channelUsersNewsByIdUrl = (newsId, byFamily = false) => `/channels/news/${newsId}/users${byFamily ? '?by_family=true' : ''}`
  static channelNewsNotifyByIdUrl = (newsId) => `/channels/news/${newsId}/notify`
  static channelUsersReadNewsByIdUrl = (newsId, isRead, byFamily = false) => `/channels/news/${newsId}/users?read=${isRead}${byFamily ? '&by_family=true' : ''}`
  static channelTranslateNewsByIdUrl = (newsId, language) => `/channels/news/${newsId}/translate?lang=${language}`
  static channelTranslateSurveyByIdUrl = (surveyUuid, language) => `channels/surveys/${surveyUuid}/translate?lang=${language}`

  // CALENDAR -> /channels/calendars/events
  static channelCalendarEventsGetUrl = (page, scroll) => `/channels/calendars/events?page=${page}&scroll=${scroll}`
  static channelCalendarEventsCreateUrl = () => '/channels/calendars/events'
  static channelCalendarSingleEventUrl = (eventId) => `/channels/calendars/events/${eventId}`
  static channelCalendarEventsDeleteUrl = (eventId) => `/channels/calendars/events/${eventId}`
  static channelCalendarEventsByDateRangeGetUrl = (from, to, fields = []) => `/channels/calendars/events/dateRange?from=${from}&to=${to}&fields=${fields}`

  // NOTIFICATION CENTRE -> /notifications
  static notificationSeenUrl = (messageUuid) => `/notifications/${messageUuid}/seen`
  static notificationUnseenUrl = (messageUuid) => `/notifications/${messageUuid}/unseen`

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // START -> /channels/*
  static async postChannelsStart (payload) {
    return axios.post(this.channelsStartUrl(), payload)
  }

  static async postChannelsStartConversation (payload) {
    return axios.post(this.channelsStartConversationUrl(), payload)
  }

  static async postChannelsJoinByCode (payload) {
    return axios.post(this.channelsJoinByCodeUrl(), payload)
  }

  static async getChannelsPersonal () {
    return axios.get(this.channelsPersonalUrl())
  }

  static async postChannelsStartTeacherParent (payload) {
    return axios.post(this.channelsStartTeacherParentUrl(), payload)
  }

  // CHANNELS -> /channels/${channelId}*
  static async getChannelsById (channelId) {
    return axios.get(this.channelsByIdUrl(channelId))
  }

  static async putChannelsById (channelId, payload) {
    return axios.put(this.channelsByIdUrl(channelId), payload)
  }

  static async putChannelsByIdLeavable (channelId, payload, config) {
    return axios.put(this.channelsByIdLeavableUrl(channelId), payload, config)
  }

  static async putChannelsByIdMute (channelId, payload, config) {
    return axios.put(this.channelsByIdMuteUrl(channelId), payload, config)
  }

  static async postChannelsByIdLeave (channelId) {
    return axios.post(this.channelsByIdLeaveUrl(channelId))
  }

  static async putChannelsByIdGenerateCode (channelId) {
    return axios.put(this.channelsByIdGenerateCodeUrl(channelId))
  }

  static async postChannelsByIdArchive (channelId) {
    return axios.post(this.channelsByIdArchiveUrl(channelId))
  }

  static async postChannelsByIdUnarchive (channelId) {
    return axios.post(this.channelsByIdUnarchiveUrl(channelId))
  }

  static async getChannelsByIdNews (channelId) {
    return axios.get(this.channelsByIdNewsUrl(channelId))
  }

  static async putChannelsByIdOneWayToggle (channelId, payload, config) {
    return axios.put(this.channelsByIdOneWayToggleUrl(channelId), payload, config)
  }

  static async putChannelsByIdState (channelId, payload) {
    return axios.put(this.channelsByIdStateUrl(channelId), payload)
  }

  static async postChannelsByIdClearMessages (channelId) {
    return axios.post(this.channelsByIdClearMessagesUrl(channelId))
  }

  static async putChannelsByIdMemberlist (channelId, payload) {
    return axios.put(this.channelsByIdMemberlistUrl(channelId), payload)
  }

  static async putChannelsByIdFullHistory (channelId, payload) {
    return axios.put(this.channelsByIdFullHistoryUrl(channelId), payload)
  }

  static async putChannelsByIdVoiceMessages (channelId, payload) {
    return axios.put(this.channelsByIdVoiceMessagesUrl(channelId), payload)
  }

  static async getChannelsByIdMetrics (channelId) {
    return axios.get(this.channelsByIdMetrics(channelId))
  }

  // USERS -> /channels/${channelId}/users*
  static async getChannelsUsersById (channelId) {
    return axios.get(this.channelsByIdUsersUrl(channelId))
  }

  static async optionsChannelsUsersById (channelId) {
    return axios.options(this.channelsByIdUsersUrl(channelId))
  }

  static async postChannelsByIdUsersRemove (channelId, payload) {
    return axios.post(this.channelsByIdUsersRemoveUrl(channelId), payload)
  }

  static async postChannelsByIdUsersAdd (channelId, payload) {
    return axios.post(this.channelsByIdUsersAddUrl(channelId), payload)
  }

  static async postChannelsByIdUsersToggleAdmin (channelId, payload) {
    return axios.post(this.channelsByIdUsersToggleAdminUrl(channelId), payload)
  }

  // MESSAGE -> /channels/${channelId}/messages*
  static async getChannelChatMessagesSearch (page, search) {
    return axios.get(this.channelChatMessagesSearchUrl(), { params: { page, search } })
  }

  // CONFERENCES -> /channels/${channelId}/conferences/*
  static async postChannelsByIdConferences (channelId, payload) {
    return axios.post(this.channelsByIdConferencesUrl(channelId), payload)
  }

  // CONFERENCES -> /channels/${channelId}/conferences/${conferenceId}*
  static async putChannelsByIdConferencesByIdFeedback (channelId, conferenceId, payload) {
    return axios.put(this.channelsByIdConferencesByIdFeedbackUrl(channelId, conferenceId), payload)
  }

  static async getChannelsByIdConferencesById (channelId, conferenceId) {
    return axios.get(this.channelsByIdConferencesByIdUrl(channelId, conferenceId))
  }

  static async postChannelsByIdEndConferencesById (channelId, conferenceId, payload) {
    return axios.post(this.channelsByIdEndConferencesByIdUrl(channelId, conferenceId), payload)
  }

  static async deleteChannelsByIdConferencesByIdFeedback (channelId, conferenceId) {
    return axios.delete(this.channelsByIdConferencesByIdFeedbackUrl(channelId, conferenceId))
  }

  static async postChannelsByIdConferencesByIdJoin (channelId, conferenceId, payload) {
    return axios.post(this.channelsByIdConferencesByIdJoinUrl(channelId, conferenceId), payload)
  }

  // CHAT -> /channels/chats/${chatId}*
  static async postChannelChatByIdRead (chatId, config) {
    return axios.post(this.channelChatByIdReadUrl(chatId), config)
  }

  static async postChannelChatByIdUnRead (chatId, payload) {
    return axios.post(this.channelChatByIdUnReadUrl(chatId), payload)
  }

  static async postChannelsByIdPin (chatId, payload) {
    return axios.post(this.channelsByIdPinUrl(chatId), payload)
  }

  // CHAT -> /channels/chats/${chatId}/messages*
  static async getChannelChatByIdMessageByDate (chatId, page, date, config) {
    return axios.get(this.channelChatByIdMessageByDateUrl(chatId, page, date), config)
  }

  static async getChannelChatByIdReadersPaginatedSearch (chatId, messageId, page, searchVal) {
    return axios.get(this.channelChatByIdReadersPaginatedSearchUrl(chatId, messageId, page, searchVal))
  }

  static async postChannelChatByIdMessages (chatId, payload, config) {
    return axios.post(this.channelChatByIdMessagesUrl(chatId), payload, config)
  }

  static async postChannelChatByIdMessagesForward (chatId, payload, config) {
    return axios.post(this.channelChatByIdMessagesForwardUrl(chatId), payload, config)
  }

  static async getChannelChatByIdMessages (chatId) {
    return axios.get(this.channelChatByIdMessagesUrl(chatId))
  }

  static async getChannelChatByIdMessagesPaginated (chatId, page, only_unseen) {
    return axios.get(this.channelChatByIdMessagesPaginatedUrl(chatId, page, only_unseen))
  }

  static async getChannelChatByIdMessageById (chatId, messageId, config) {
    return axios.get(this.channelChatByIdMessageByIdUrl(chatId, messageId), config)
  }

  static async getChannelChatMessages (chatId, params = {}) {
    return axios.get(this.channelChatByIdMessagesUrl(chatId), { params })
  }

  static async deleteChannelChatByIdMessageById (chatId, messageId, config) {
    return axios.delete(this.channelChatByIdMessageByIdUrl(chatId, messageId), config)
  }

  static async postChannelChatByIdSurvey (chatId, payload, config) {
    return axios.post(this.channelChatByIdSurveyUrl(chatId), payload, config)
  }

  static async postChannelChatByIdKnock (chatId, payload) {
    return axios.post(this.channelChatByIdKnockUrl(chatId), payload)
  }

  static async postChannelChatByIdVoice (chatId, payload, config = {}) {
    return axios.post(this.channelChatByIdVoiceUrl(chatId), payload, config)
  }

  // CLOUD -> /channels/cloud/${cloudId}*
  static async getChannelCloudById (cloudId) {
    return axios.get(this.channelCloudByIdUrl(cloudId))
  }

  static async postChannelCloudByIdUpload (cloudId, payload, config) {
    return axios.post(this.channelCloudByIdUploadUrl(cloudId), payload, config)
  }

  // CLOUD -> /channels/cloud/${cloudId}/files*
  static async getChannelCloudByIdFilesByPath (cloudId, path, config) {
    return axios.get(this.channelCloudByIdFilesByPathUrl(cloudId, path), config)
  }

  static async getChannelCloudByIdFileById (cloudId, fileId) {
    return axios.get(this.channelCloudByIdFileByIdUrl(cloudId, fileId))
  }

  static async putChannelCloudByIdFileById (cloudId, fileId, payload) {
    return axios.put(this.channelCloudByIdFileByIdUrl(cloudId, fileId), payload)
  }

  static async putChannelCloudByIdFileByIChangeCollaboration (cloudId, fileId, payload) {
    return axios.put(this.channelCloudByIdFileByIChangeCollaborationUrl(cloudId, fileId), payload)
  }

  static async putChannelCloudByIdMoveFiles (cloudId, payload) {
    return axios.put(this.channelCloudByIdMoveFilesUrl(cloudId), payload)
  }

  static async postChannelCloudByIdCreateDir (cloudId, payload) {
    return axios.post(this.channelCloudByIdCreateDirUrl(cloudId), payload)
  }

  static async postChannelCloudByIdCreate (cloudId, payload) {
    return axios.post(this.channelCloudByIdCreateUrl(cloudId), payload)
  }

  static async putChannelCloudByIdRenameFile (cloudId, payload, config) {
    return axios.put(this.channelCloudByIdRenameFileUrl(cloudId), payload, config)
  }

  static async deleteChannelCloudByIdDeleteFile (cloudId, payload, config) {
    return axios.delete(this.channelCloudByIdDeleteFileUrl(cloudId), { params: payload }, config)
  }

  // SURVEYS -> /channels/surveys/*
  static async postChannelSurvey (payload) {
    return axios.post(this.channelSurveyUrl(), payload)
  }

  static async deleteChannelSurvey (surveyUuid) {
    return axios.delete(this.channelSurveyByIdUrl(surveyUuid))
  }

  // SURVEYS -> /channels/surveys/${surveyId}*
  static async getChannelSurveyById (surveyId) {
    return axios.get(this.channelSurveyByIdUrl(surveyId))
  }

  static async putChannelEndSurveyById (surveyId) {
    return axios.put(this.channelEndSurveyByIdUrl(surveyId))
  }

  static async putChannelVoteSurveyById (surveyId, payload) {
    return axios.put(this.channelVoteSurveyByIdUrl(surveyId), payload)
  }

  static async deleteChannelVoteSurveyById (surveyId) {
    return axios.delete(this.channelVoteSurveyByIdUrl(surveyId))
  }

  // NEWS -> /channels/news/*
  static async postChannelNews (payload, config) {
    return axios.post(this.channelNewsUrl(), payload, config)
  }

  static async postChannelNewsUpload (payload, config) {
    return axios.post(this.channelNewsUploadUrl(), payload, config)
  }

  static async deleteChannelNewsAttachment (payload, config) {
    return axios.post(this.channelNewsDeleteAttachmentUrl(), payload, config)
  }

  static async postChannelNewsAiContent (payload) {
    return axios.post(this.channelNewsAiContentUrl(), payload, { timeout: 60000 })
  }

  static async postChannelNewsAiTextFeedback (payload) {
    return axios.post(this.channelNewsAiTextFeedbackUrl(), payload, { timeout: 60000 })
  }

  // NEWS -> /channels/news/${newsId}*
  static async getChannelNewsById (newsId) {
    return axios.get(this.channelNewsByIdUrl(newsId))
  }

  static async postNewsNotifyById (newsId) {
    return axios.post(this.channelNewsNotifyByIdUrl(newsId))
  }

  static async putChannelNewsAttachmentById (attachmentId, payload) {
    return axios.put(this.channelNewsAttachmentByIdUrl(attachmentId), payload)
  }

  static async putChannelNewsById (newsId, payload) {
    return axios.put(this.channelNewsByIdUrl(newsId), payload)
  }

  static async deleteChannelNewsById (newsId, payload) {
    return axios.delete(this.channelNewsByIdUrl(newsId), { params: payload })
  }

  static async putChannelConfirmNewsById (newsId) {
    return axios.put(this.channelConfirmNewsByIdUrl(newsId))
  }

  static async putChannelPinNewsById (newsId, payload) {
    return axios.put(this.channelPinNewsByIdUrl(newsId), payload)
  }

  static async getChannelTranslateNewsById (newsId, language) {
    return axios.get(this.channelTranslateNewsByIdUrl(newsId, language))
  }

  static async getChannelTranslateSurveyById (surveyUuid, language) {
    return axios.get(this.channelTranslateSurveyByIdUrl(surveyUuid, language))
  }

  static async getChannelTranslateMessageById (messageId, language, channelId) {
    return axios.get(this.channelTranslateMessageByChannelIdUrl(messageId, language, channelId))
  }

  static async getChannelTranslationSupportedLanguages () {
    return axios.get(this.channelTranslationSupportedLanguagesUrl())
  }

  // CALENDAR -> /channels/calendar/events
  static async getCalendarEvents (page, scroll) {
    return axios.get(this.channelCalendarEventsGetUrl(page, scroll))
  }

  static async postCreateCalendarEvent (event) {
    return axios.post(this.channelCalendarEventsCreateUrl(), event)
  }

  static async putUpdateCalendarSingleEvent (eventId, payload) {
    return axios.put(this.channelCalendarSingleEventUrl(eventId), payload)
  }

  static async getCalendarSingleEvent (eventId, config) {
    return axios.get(this.channelCalendarSingleEventUrl(eventId), config)
  }

  static async deleteChannelCalendarEvent (eventId, payload) {
    return axios.delete(this.channelCalendarEventsDeleteUrl(eventId), { params: payload })
  }

  static async getChannelCalendarEventsByDateRangeGet (from, to, fields) {
    return axios.get(this.channelCalendarEventsByDateRangeGetUrl(from, to, fields))
  }

  // NOTIFICATION CENTRE -> /notifications
  static async putNotificationStatusSeen (messageUuid) {
    return axios.put(this.notificationSeenUrl(messageUuid))
  }

  static async putNotificationStatusUnseen (messageUuid) {
    return axios.put(this.notificationUnseenUrl(messageUuid))
  }

  // CONTENT MOVE -> /channels/*
  static async getChannelAvailForContentMove () {
    return axios.get(this.channelAvailForContentMoveUrl())
  }

  static async getSingleRelatedChannelForContentMove (channelId) {
    return axios.get(this.channelSingleRelatedChannelForContentMoveUrl(channelId))
  }

  static async getRelatedChannelsForContentMove (channelId) {
    return axios.get(this.channelRelatedChannelsForContentMoveUrl(channelId))
  }

  static async putChannelContentMoveArchive (channelId) {
    return axios.put(this.channelContentMoveArchiveUrl(channelId))
  }

  static async putChannelContentMoveStartEmpty (channelId) {
    return axios.put(this.channelContentMoveStartEmptyUrl(channelId))
  }

  static async postChannelContentMoveSubmit (payload) {
    return axios.post(this.channelContentMoveSubmitUrl(), payload)
  }
}
